import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Pagination, Radio, Stack, Switch, TextField, Grow, Grid } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToLogin, goToUsers } from "../../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";

function UseQuery() {
  console.log(window.location)
  return new URLSearchParams(window.location.search)
}

const UserRecord = () => {
  const { form, onChangeForm, clear } = useForm({ name: "", role: "", group_id: "", email: "", password: "123mudar" });
  const [name, setName] = useState("")
  const [role, setRole] = useState("")
  const [group_name, setGroupName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("123mudar")
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();

  const icon = (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={12} lg={6}>
        <TextField
          name={"group_id"}
          onChange={(e) => setGroupName(e.target.value)}
          value={group_name}
          label={"Nome do Grupo"}
          variant={"outlined"}
          required
          type={"group_id"}
          fullWidth
        />
      </Grid>
    </Grid>
  );

  const handleChange = () => {
    setChecked((prev) => !prev);
  };

  const save = () => {
    let id = UseQuery().get("id")

    if (!id) {
      newUser()
    } else {
      EditUser()
    }
  }
  const newUser = () => {
    const group_id = parseInt(localStorage.getItem("group_id"))
    if (checked === false) {
      axios.post(`${process.env.REACT_APP_BASE_URL}/users`, { user: { name, email, role, group_id, password } },
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "token-type": localStorage.getItem("token-type"),
            "expiry": localStorage.getItem("expiry"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"

          }
        })
        .then((resposta) => {
          alert("Usuário cadastrado com sucesso!")
          goToUsers(navigate)
        })
        .catch((erro) => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
        }
        )
    } else {
      newGroup()
    }
  }
  const newGroup = () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}/users`, {user: { name, email, role, password, group_attributes: { name: group_name } }},
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "token-type": localStorage.getItem("token-type"),
          "expiry": localStorage.getItem("expiry"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"

        }
      })
      .then((response) => {
        goToUsers(navigate)
      })
      .catch((erro) => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      }
      )
  }


  const EditUser = () => {

    let id = UseQuery().get("id")
    let url = `${process.env.REACT_APP_BASE_URL}/users/${id}`
    axios.put(url, { user: { name, email, role } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        goToUsers(navigate)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }

  const Show = () => {
    let id = UseQuery().get("id")
    if (id) {
      let url = `${process.env.REACT_APP_BASE_URL}/users/${id}`

      axios.get(url,
        {
          headers: {
            "access-token": localStorage.getItem("access-token"),
            "client": localStorage.getItem("client"),
            "expiry": localStorage.getItem("expiry"),
            "token-type": localStorage.getItem("token-type"),
            "uid": localStorage.getItem("uid"),
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          setName(response.data.name)
          setEmail(response.data.email)
          const rolereturn = { 'Gerencial': 'manager', 'Técnico': 'technician', 'Contador': 'counter' }
          setRole(rolereturn[response.data.role])
        })
        .catch(erro => {
          Object.keys(erro.response.data).forEach((item) => {
            alert(erro.response.data[item]);
          });
          if(erro.response.status === 401){
            goToLogin(navigate)
          }
        })
    }
  }

  useEffect(() => {
    Show()

  }, [])
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Cadastrar Usuário</Typography>
          <Divider />
          <form>
            <Typography sx={{ paddingTop: 1 }} variant="h3">Dados</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container columnSpacing={3}>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                     name={"name"}
                     required
                     id="outlined-required"
                     onChange={(e) => setName(e.target.value)}
                     value={name}
                     label={"Nome"}
                     type={"name"}
                    fullWidth
                    sx={{
                      mb: 2,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    name={"email"}
                    required
                    id="outlined-required"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    label={"Email"}
                    type={"email"}
                    fullWidth
                    sx={{
                      mb: 2,
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Typography variant="h3">Perfil</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="gender"
                  defaultValue=""
                  name="role"
                  required
                  id="outlined-required"
                  onChange={(e) => setRole(e.target.value)}
                  value={role}
                  label={"Role"}
                  type={"role"}
                >
                  <FormControlLabel
                    value="manager"
                    control={<Radio />}
                    label="Gerencial"
                  />
                  <FormControlLabel
                    value="technician"
                    control={<Radio />}
                    label="Técnico"
                  />
                  <FormControlLabel
                    value="counter"
                    control={<Radio />}
                    label="Contador"
                  />
                </RadioGroup>
              </FormControl>
            </CardContent>
            <Typography variant="h3">Grupo</Typography>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <FormControlLabel
                control={<Switch checked={checked} onChange={handleChange} />}
                label="Usuário pertence a um novo grupo"
              />
              <Box sx={{ display: 'flex' }}>

                <Grow in={checked}>{icon}</Grow>

              </Box>
            </CardContent>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <Box>
                <Button onClick={save} variant="contained" color="success" startIcon={<AddIcon />}>
                  Salvar
                </Button>
                <Button onClick={() => goToUsers(navigate)} variant="outlined" startIcon={<ArrowBackIosIcon />}>
                  Voltar
                </Button>
              </Box>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserRecord;